/*export const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

export const handleError = (response) => {
    if (!response.ok) {
        throw response.statusText; //TODO better
    }
    return response;
}
*/

export const  UpdateQueryString = (url : string, key:string, value:string) : string =>{

  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

  if (re.test(url)) {
      if (typeof value !== 'undefined' && value !== null) {
          return url.replace(re, '$1' + key + "=" + value + '$2$3');
      } 
      else {
          hash = url.split('#');
          url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
          if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
              url += '#' + hash[1];
          }
          return url;
      }
  }
  else {
      if (typeof value !== 'undefined' && value !== null) {
          var separator = url.indexOf('?') !== -1 ? '&' : '?';
          hash = url.split('#');
          url = hash[0] + separator + key + '=' + value;
          if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
              url += '#' + hash[1];
          }
          return url;
      }
      else {
          return url;
      }
  }
}

export const parseAPIResponse = (response: { text: () => unknown; status: number; ok: any; statusText: string; url: any; }) =>
	new Promise(resolve => resolve(response.text()))
		.catch(err =>
			// eslint-disable-next-line prefer-promise-reject-errors
			Promise.reject({
				type: 'NetworkError',
				status: response.status,
				message: err,
			}))
		.then((responseBody: any) => {
			// Attempt to parse JSON
			try {
        if (response.ok)
        {
          if(responseBody==='')
             return null;
          return JSON.parse(responseBody);
        }
				if (response.status >= 500) {
					// eslint-disable-next-line prefer-promise-reject-errors
					return Promise.reject({
						type: 'Server Error:  '+ response.statusText,
            url: response.url,
            status: response.status,
			      statusText: response.statusText,
						body: responseBody,
					});
				}
				if (response.status <= 501) {
					// eslint-disable-next-line prefer-promise-reject-errors
					return Promise.reject({
            type: 'Application Error ' + response.statusText,
            url: response.url,
            status: response.status,
            statusText: response.statusText,
						body: responseBody,
					});
				}
			} catch (e) {
				// We should never get these unless response is mangled
				// Or API is not properly implemented
				// eslint-disable-next-line prefer-promise-reject-errors
				return Promise.reject({
          message: "Invalid JSON",
					type: 'InvalidJSON',
          url: response.url,
          status: response.status,
					body: responseBody,
				});
			}
    });
  
export const getRequest = (url:string, currentJobView:any = null, model:any= null): RequestInit=> {
  if((url.startsWith("webapi/Job") || url.startsWith("/Job")) && currentJobView?.job!=null)
    return getRequestPostJob(currentJobView, model);
  else
    return  Object.assign({}, requestBase, { method: "GET" });
}
    
export const getRequestPostJob = (currentJobView: { job: any; view: { bindings: any; securityToken: any; model: any; url: any; eventSource: any; }; }, model=null) : RequestInit=> {

  var sendData = 
  {
      job: currentJobView.job,
      view: {
          bindings: currentJobView.view?.bindings,
          securityToken:  currentJobView.view?.securityToken,
          model: model || currentJobView.view?.model,
          url: currentJobView.view?.url,
          eventSource: currentJobView.view?.eventSource,
      }
  }

  if (typeof window !== "undefined") {
    return {
      method: "POST",
      body: JSON.stringify(sendData),
      credentials: "include" as RequestCredentials,
      mode: 'cors' as RequestMode,
       headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    };
  } else
    return {
      method: "POST",
      body: JSON.stringify(sendData),
      credentials: "include" as RequestCredentials,
      // mode: 'cors',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
};

export const requestBase : RequestInit = (() => {
  if (typeof window !== "undefined") {
    return {
      method: "POST",

      credentials: "include" as RequestCredentials,
      mode: 'cors' as RequestMode,
       headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    };
  } else
    return {
      method: "POST",
      credentials: "include" as RequestCredentials,
      // mode: 'cors',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
})();

export const requestFormBase : RequestInit= (() => {
    if (typeof window !== "undefined") {
        return {
            method: "POST",
            credentials: "include" as RequestCredentials,
            mode: 'cors' as RequestMode,
            headers: new Headers({
                Accept: "application/x-www-form-urlencoded",
                "Content-Type": "application/x-www-form-urlencoded",
            }),
        };
    } else
        return {
            method: "POST",
            credentials: "include" as RequestCredentials,
            // mode: 'cors',
            headers: {
                Accept: "application/x-www-form-urlencoded",
                "Content-Type": "application/x-www-form-urlencoded",
            },
        };
})();

export const formatBytes = (bytes: number, decimals : number = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
